import { render, staticRenderFns } from "./MotivoFotoList.vue?vue&type=template&id=be4e84e0&scoped=true"
import script from "./MotivoFotoList.vue?vue&type=script&lang=js"
export * from "./MotivoFotoList.vue?vue&type=script&lang=js"
import style0 from "./MotivoFotoList.vue?vue&type=style&index=0&id=be4e84e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e84e0",
  null
  
)

export default component.exports